export enum AccountOnboardingStep {
  ConnectOrg = 'ConnectOrg',
  Completed = 'Completed',
}
